// src/config.js
const config = {
    apiBaseURL: process.env.REACT_APP_API_BASE_URL || 'http://valuesieve.com:3000',
    appName: 'ValueSieve',
    version: '1.0.0',
    launchDarklyClientId: process.env.REACT_APP_LAUNCHDARKLY_CLIENT_ID || '',
  };

  export default config;
